<template>
	<div class="decorator-container" :class="style()">
		<div class="frills-image frills-top"></div>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		props: {
			name: {
				type: String,
				default: 'frills',
			},
		},
		methods: {
			style() {
				// TODO use name to apply multiple style
				return this.name;
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/call-to-action';
	.decorator-container {
		position: relative;
		.frills-top {
			top: -45px;
			background-color: $greyBackground;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseDecorator.vue